import axios from "axios";
import { convertComponentToBase64 } from "./exportComponentToImage";
import { Buffer } from "buffer";

export const sendQuizzResult = async (email, flowerRef) => {
  const flowerInBase64 = await convertComponentToBase64(flowerRef);
  const baseURL =
    email &&
    `https://fermesdavenir.org/wp-json/fleur-agroecologique/v1/fleur/${email}/`;
  const username = "fermesdavenir";
  const password = "TXEe cQKz rcOQ Azcw nSgw AiCk";
  return axios.post(baseURL, flowerInBase64, {
    headers: {
      Authorization:
        "Basic " +
        Buffer.from(username + ":" + password, "utf-8").toString("base64"),
      "Content-type": "image/jpeg",
    },
  });
};
